module.exports = __webpack_public_path__ + "static/img/news46_4.bdb9d79.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/components/open/panels/news/img/detail/activity/news46/news46_4.jpeg
// module id = zYbl
// module chunks = 0